export default "__VITE_ASSET__62e7e3b5__"